import { supabase } from "../lib/supabase"

export async function channelDelete(channelId: string) {
  const { error } = await supabase.from("db").delete().eq("id", channelId)

  if (error) throw new Error(error.message)
}
